'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import Badge from '../Badge/Badge';
import styles from './Tab.module.scss';

type TabItem = { key: string; text: string; showBadge?: boolean; url?: string };

type Props = {
  tabKey: string;
  tabItems: Array<TabItem>;
  isTextBold?: boolean;
};

function Tab({ tabKey, tabItems, isTextBold = false }: Props) {
  const router = useRouter();
  const itemWidth = 100 / tabItems.length;

  const handleClick = (item: TabItem) => {
    // URLが設定されていればそちらに遷移
    if (item.url) {
      router.push(item.url as Route);
      return;
    }

    // URLを書き換える
    const params = new URLSearchParams(location.search);
    params.set('tab', item.key);
    // ページを保持してタブ遷移するパターンはなさそうなので、ページングパラメータがある場合は削除
    if (params.get('page')) {
      params.delete('page');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  return (
    <ul className={styles.tabs}>
      {tabItems.map((item) => (
        <li
          className={`${isTextBold ? utilsStyles.textBold : ''} ${styles.tabItem} ${
            item.key === tabKey ? styles.active : styles.inActive
          }`}
          style={{ width: `${itemWidth}%` }}
          key={item.key}
          onClick={() => handleClick(item)}
        >
          <span className={styles.tabText}>
            {item.text}
            {item.showBadge && (
              <div className={styles.menuBadge}>
                <Badge color='primary' />
              </div>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}

export default Tab;
